module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Percusion RO.2ef91176.png";